/*
 * @Author: your name
 * @Date: 2021-05-27 08:43:33
 * @LastEditTime: 2021-11-15 14:34:32
 * @LastEditors: sueRimn
 * @Description: In User Settings Edit
 * @FilePath: \app-project\src\i18n\language\th.js
 */
const th = {
  message: {
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    firstTitle: 'aohai ถนนตำบลตำบลตำบลเนินเขาทางใต้ของออสเตรเลียถนน Nanshan ตำบลตำบลถนน Nanshan ตำบลตำบลบ้าน Nanshan ตำบลถนนบ้าน Nanshan ตำบลถนนบ้านถนนบ้าน Nanhai ตำบล',
    secondTitle: 'หนึ่งถนนบ้าน Nanshan ตำบลถนนบ้าน Nanhai ตำบลถนน Nanshan ตำบลถนนบ้าน Nanshan ตำบลถนนบ้าน Nanshan ตำบลถนนบ้าน Nanshan ตำบลถนนบ้านถนนบ้าน Nanhai ตำบลบ้าน Nanshan ตำบลโอ๊กถนนบ้าน Nanshan ตำบล',
    thirdTitle: 'ประการที่สองถนนบ้านน่านซานตำบลถนนบ้าน Nanshan ตำบลบ้าน Nanshan ตำบลบ้านถนนบ้าน Nanshan ตำบลถนนบ้าน Nanshan ตำบลบ้านถนนบ้าน Nanshan ตำบลบ้านถนนบ้าน Nanhai ตำบลบ้านถนนบ้าน Nanshan ตำบลบ้านถนนบ้าน Nanhai ถนนบ้านเนินเขาอ่าว',
    fourTitle: 'ประการที่สามถนนบ้านนัมซานตำบลถนนบ้านนัมซานตำบลบ้านนันซานตำบลถนนบ้านนันซานตำบลบ้านนันซานตำบลถนนบ้านนัมซานถนนบ้านนัมซานถนนบ้านถนนบ้านนัมซานตำบลบ้านนันซานถนนบ้านนันไห่อ่าวถนนบ้',
    serviceTerms: 'ข้อตกลงการให้บริการ',
    warehouseToday: 'สินค้าขาเข้าวันนี้',
    stockToday: 'สินค้าขาออกวันนี้',
    yesterdayEnterQuantity: 'สินค้าเข้าเมื่อวาน',
    yesterdayOutQuantity: 'สินค้าออกเมื่อวาน',
    deliveryInventory: 'จัดส่งสินค้าคงคลัง',
    retentionQuantity: 'พัสดุที่เหลือ',
    sevenDaySendQuantity: 'ปริมาณการส่งใน 7 วัน',
    sevenDayPickQuantity: 'น้ำหนักสะสมใน 7 วัน',
    ENTER_QUANTITY: 'ปริมาณสินค้าขาเข้า',
    OUT_QUANTITY: 'ปริมาณสินค้าขาออก',
    SEND_QUANTITY: 'ปริมาณการส่ง',
    PICK_WEIGHT: 'น้ำหนักในการขนส่ง',
    SEVEN: 'ในช่วง7 วัน',
    THIS_MONTH: 'เดือนนี้',
    LAST_MONTH: 'เดือนที่แล้ว',
    THREE_MONTHS: 'ล่าสุด 3 เดือน',
    HALF_A_YEAR: 'ล่าสุด 6 เดือน',
    piece: 'ชิ้น',

    message: 'ข้อความรับชำระเงิน',
    bankName: 'ชื่อธนาคาร:',
    KTbank: 'ธนาคารกสิกรไทย',
    bankAccounts: 'บัญชีธนาคาร',
    payeeName: 'ชื่อผู้รับเงิน',
    remark: 'หมายเหตุการโอนเงิน',
    operatingProcedures: 'ขั้นตอนการดำเนินงาน',
    remark1: '1. โอนเงินผ่านธนาคารที่แนะนำไปยังบัญชีธนาคารของเรา',
    remark2: '2. เข้าสู่ระบบ APP ส่งใบสมัครและอัปโหลดหลักฐาน;',
    remark3: '3. เจ้าหน้าที่จะดำเนินการตรวจสอบให้เสร็จสิ้นภายใน 2 วันทำการ',
    precautions: 'ข้อควรระวัง',
    precautionsRemark1: '1. เพื่อให้แน่ใจว่าการตรวจสอบของคุณสำเร็จแล้ว โปรดตรวจสอบว่าข้อมูลการชำระเงินกรอกถูกต้องหรือไม่',
    precautionsRemark2: '2. โปรดกรอกรหัสสถานีของคุณในหมายเหตุการโอนเงิน เพื่อให้เราสามารถตรวจสอบข้อมูลการโอนเงินของคุณได้',
    fundsTotal: 'จำนวนเงิน',
    formula: 'ผลรวมของเงินล่วงหน้า',
    prepayment: 'ล่วงหน้า',
    prepaymentRemarks1: 'ปัจจุบันค่าใช้จ่ายในการโอนเงินภายใต้สายสนับสนุนเท่านั้น',
    prepaymentRemarks2: 'การชำระเงินล่วงหน้าอาจจะใช้สำหรับการพิมพ์แผ่น ในอนาคตการชำระเงินล่วงหน้าสามารถใช้ได้สำหรับการซื้อ',
    prepaymentRemarks3: 'การชำระเงินล่วงหน้าไม่สามารถถอนหรือคืนเงิน',

    dayViewName: 'มุมมองรายวัน',
    weightViewName: 'มุมมองน้ำหนัก',
    dayViewLeftTabName: 'ปริมาณสินค้าขาออก',
    dayViewRightTabName: 'ค่าจัดส่ง',
    dayViewTableCol1Name: 'วันที่',
    dayViewTableCol2Name: 'ปริมาณสินค้าขาออก',
    dayViewTableCol3Name: 'ค่าธรรมเนียมการจัดส่ง（฿）',
    dayViewTableNullData: 'ไม่มีข้อมูล',
    dayViewDataTotalLeft: 'ปริมาณสินค้าขาออก（กระทง）',
    dayViewDataTotalRight: 'ค่าธรรมเนียมการจัดส่ง （฿）',
    weightViewPieDataTotal: 'ปริมาณสินค้าขาออก',
    weightViewTableCol1Name: 'กิโลกรัม',
    weightViewTableCol2Name: 'เปอร์เซ็นต์',
    weightViewTableCol3Name: 'ปริมาณสินค้าขาออก/ค่าธรรมเนียมการจัดส่ง（฿）',
    weightViewTableNullData: 'ไม่มีข้อมูล',
    weightViewDetailTableCol1Name: 'เลขใบนำส่ง',
    weightViewDetailTableCol2Name: 'นน.ที่ใช้คิดเงิน（kg）',
    weightViewDetailTableCol3Name: 'ค่าธรรมเนียมการจัดส่ง（฿）',
    weightViewDetailTableNullData: 'ไม่มีข้อมูล',
    weightViewDetailDataTotalLeft: 'ปริมาณสินค้าขาออก（กระทง）',
    weightViewDetailDataTotalRight: 'ค่าธรรมเนียมการจัดส่ง（฿）',
    dataSelectTitle: 'เลือกเวลา',
    dataSelectTimeConnectText: '-',
    dataSelectConfirmText: 'ตกลง',
    dataSelectCancelText: 'ยกเลิก',
    idcard1: 'ด้วยเหตุผลด้านความปลอดภัยและข้อกำหนดตามกฏหมาย ผู้ส่งจะต้องแนบเอกสารประจำตัวส่วนบุคคล (เช่น บัตรประชาชนหรือหนังสือเดินทาง) ให้กับเจ้าหน้าที่ของเราเพื่อทำการบันทึกข้อมูลการจัดส่งพัสดุ ',
    idcard2: 'โปรดแนบไฟล์',
    idcard3: 'ชื่อจริง',
    idcard4: 'เลขประจำตัวประชาชน',
    idcard5: 'กรุณาแนบรูปภาพไฟล์ jpg,jpeg,png',
    idcard6: 'แนบไฟล์รูปภาพขนาดไม่เกิน 10 MB',
    idcard7: 'อัปโหลด',
    idcard8: 'อัปโหลดสำเร็จ',
    idcard9: 'กรุณาแนบไฟล์',
    idcard10: 'ต้องระบุหมายเลขประจำตัวประชาชน',
    idcard11: 'ชื่อ-นามสกุลไม่สามารถเว้นว่าง',
    idcard12: 'ยืนยันสำเร็จ',
    idcard13: 'การอัปโหลดล้มเหลว',
    idcard14: 'กรุณากรอกเลขบัตรประชาชนไทย 13 หลัก',
    idcard15: 'ดูเหมือนว่าหน้าจะหายไป!',
    idcard16: 'ประเภทของใบรับรอง',
    idcard17: 'ID card',
    idcard18: 'PASSPORT',
    idcard19: 'ชื่อหนังสือเดินทาง',
    idcard20: 'หนังสือเดินทางเลขที่',
    idcard21: 'หมายเลขหนังสือเดินทางมีความยาว 1-30 หลัก',
    stayBackQuantity: 'รอส่งคืน',
    zhi: 'ถึง',
    detail: 'ดูรายละเอียด',
    dateSelect: 'วันที่ค้นหา',
    CODConfirmText: 'ยืนยันการส่งมอบ',
    package: 'จำนวนพัสดุเก็บปลายทาง',
    amount: 'จำนวนพัสดุสำหรับ COD',
    outbound: 'รายละเอียดพัสดุออกคลังของ COD',
    confirmed: 'ยืนยันเรียบร้อย',
    unconfirmed: 'รอการยืนยัน',
    outboundTime: 'เวลาสินค้าออก',
    courierSignature: 'ลายเซ็นของพนักงานขนส่ง',
    sign: 'ลายเซ็น',
    clear: 'ล้าง',
    submit: 'บันทึก',
    waybillNo: 'เลขใบนำส่ง',
    codRecord: 'บันทึกการส่งมอบ',
    Total: 'รวม',
    CreateHandover: 'สร้างการส่งมอบ',
    systemSwitch: 'สลับระบบ',
    systemSwitchDesc: 'คำแนะนำการสลับระบบ:',
    warmTips: 'ข้อควรระวัง:',
    systemSwitchNotice: 'ระบบของคุณจะถูกสลับเร็วๆ นี้ ระบบเก่าจะถูกยกเลิกหลังจากการสลับ กรุณาบันทึก URL WEB ของระบบใหม่ล่วงหน้าและดำเนินการติดตั้ง APP ที่เกี่ยวข้อง หากมีคำถาม กรุณาติดต่อเจ้าหน้าที่ IT',
    newSystemWebUrl: '1. URL WEB ระบบใหม่',
    newSystemApp: '2. APP ระบบใหม่',
    android: '(1) Android',
    ios: '(2) iOS',
    iosStoreDownload: 'หรือค้นหาและดาวน์โหลดจาก iOS App Store'
  }
}
export default th



// WEBPACK FOOTER //
// ./src/i18n/language/th.js